export default __webpack_public_path__ + "static/media/AfterPhoto12.3cfd54e4.jpg";